<template>
  <div id="app" class="row mx-0">
    <div v-if="storeState.dashboard" class="col-12 mb-5">
      <!-- view navigation -->
      <div class="row mb-4">
        <div class="col-12 d-flex px-md-0">
          <div
            class="select-view"
            @click="view = 'country-table-targets'"
            :class="{ selected: view === 'country-table-targets' }"
          >
            Targets
          </div>
          <div
            class="select-view"
            @click="view = 'mitigation-table-measures'"
            :class="{ selected: view === 'mitigation-table-measures' }"
          >
            Climate actions for reducing emissions
          </div>
          <div
            class="select-view"
            @click="view = 'adaptation-table-measures'"
            :class="{ selected: view === 'adaptation-table-measures' }"
          >
            Climate actions for adapting to impacts
          </div>
          <div
            class="select-view"
            @click="view = 'country-table-misc'"
            :class="{ selected: view === 'country-table-misc' }"
          >
            Process and benefits
          </div>
        </div>
      </div>
      <sortable-table :view="view" :data="tableData"></sortable-table>
    </div>
  </div>
</template>
<script>
import SortableTable from './components/SortableTable.vue';
import { store } from './Store.js';
import ColorMixin from './mixins/ColorMixin.js';
import StoreMixin from './mixins/StoreMixin.js';
import './localdev.js';
import paths from './Paths.js';
export default {
  name: 'App',
  components: {
    SortableTable,
  },
  mixins: [ColorMixin, StoreMixin],
  data() {
    return {
      storeState: store.state,
      paths: paths,
      view: 'country-table-targets',
      x: 0,
      y: 0,
      tip: null,
    };
  },
  async mounted() {
    store.get();
  },

  computed: {
    filteredProofs() {
      return this.storeState.dashboard.proofs;
    },
    tableData() {
      let header = [];
      let entries = [];
      let sorting = '';
      switch (this.view) {
        case 'country-table-targets':
          header = [
            { label: 'Submitted documents', sortKey: 'documenttype', width: '15%' },
            { label: 'Target', sortKey: 'target', width: '15%' },
//            { label: 'Target types', sortKey: '', width: '20%' },
            { label: 'Target year', sortKey: 'planned', width: '10%' },
            { label: 'Source and quote', sortKey: '', width: '40%' },
//            { label: 'Document type', sortKey: '', width: '20%' },
          ];
          entries = this.listTargetTypeIndicators;
          sorting = 'target';
          break;
        case 'mitigation-table-measures':
          header = [
            // { label: 'Attributes', sortKey: '', width: '25%' },
            { label: 'Submitted documents', sortKey: 'documenttype', width: '15%' },
            { label: 'Climate action', sortKey: 'action', width: '15%' },
            { label: 'Source and quote', sortKey: '', width: '50%' },
//            { label: 'Document type', sortKey: '', width: '20%' },
          ];
          entries = this.listMitigationTypeIndicators;
          sorting = '';
          break;
        case 'adaptation-table-measures':
          header = [
            // { label: 'Attributes', sortKey: '', width: '25%' },
            { label: 'Submitted documents', sortKey: 'documenttype', width: '15%' },
            { label: 'Climate action', sortKey: 'action', width: '15%' },
            { label: 'Source and quote', sortKey: '', width: '50%' },
//            { label: 'Document type', sortKey: '', width: '20%' },
          ];
          entries = this.listAdaptationTypeIndicators;
          sorting = '';
          break;
        case 'country-table-misc':
          header = [
            { label: 'Submitted documents', sortKey: 'documenttype', width: '20%' },
            { label: 'Other parameters', sortKey: 'params', width: '30%' },
            { label: 'Source and quote', sortKey: '', width: '50%' },
          ];
          entries = this.listOtherAttrIndicators;
          sorting = 'params';
          break;
      }
      return { header: header, entries: entries, sorting: sorting };
    },
  },
};
</script>
